import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
import { ENVIRONMENT } from './environments/environment';
import { enableProdMode } from '@angular/core';

defineCustomElements(window);
if (ENVIRONMENT.PRODUCTION) {
  enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).then(() => {
  defineCustomElements(window);
}).catch((err) =>
  console.error(err),
);
